import './App.css';
import { FirebaseContext } from './Components/Firebase';
import { useContext } from 'react';
import Dashboard from './Components/Dashboard';
import LeftPanel from './Components/LeftPanel';
import RightPanel from "./Components/RightPanel";
import {atom} from "recoil";


export const selectedState = atom({
    key: 'selectedState', // unique ID (with respect to other atoms/selectors)
  default: {selected: false,name:"",lat:undefined,lng:undefined,violation:"",time:"",imagepath:""}, // default value (aka initial value)
});

function App() {


  return (
    //<CenterPanel firebase={firebase}/>
    <div className="flex flex-row h-screen">
      <div className="w-96 flex-none bg-white text-white border-r"><LeftPanel /></div>
      <div className="flex-grow bg-white"><RightPanel /></div>
    </div>
  );
}

export default App;
